import Vue from '../../lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '../../lib/utils/vue3compat/vue_apollo.js?vue3';
import VueRouter from '../../lib/utils/vue3compat/vue_router.js?vue3';
import { parseBoolean } from '@gitlab/frontend-utils';
import { initVueApp } from '../../lib/utils/vue3compat/init_vue_app.js?vue3';
import { defaultClient } from '../../graphql_shared/issuable_client.js?vue3';
import MergeRequestsListApp from './components/merge_requests_list_app.vue?vue3';
import issuableBulkUpdateActions from './issuable_bulk_update_actions.js?vue3';
import IssuableBulkUpdateSidebar from './issuable_bulk_update_sidebar.js?vue3';

export function initBulkUpdateSidebar(prefixId) {
  const el = document.querySelector('.issues-bulk-update');

  if (!el) {
    return;
  }

  issuableBulkUpdateActions.init({ prefixId });
  new IssuableBulkUpdateSidebar(); // eslint-disable-line no-new
}

export async function mountMergeRequestListsApp({
  getMergeRequestsQuery,
  getMergeRequestsCountsQuery,
  getMergeRequestsApprovalsQuery,
  exportMergeRequestsCsvMutation,
  isProject = true,
} = {}) {
  const el = document.querySelector('.js-merge-request-list-root');

  if (!el) {
    return null;
  }

  Vue.use(VueApollo);
  Vue.use(VueRouter);

  const {
    autocompleteAwardEmojisPath,
    mergeRequestSourceBranchesPath,
    mergeRequestTargetBranchesPath,
    fullPath,
    namespaceId,
    hasAnyMergeRequests,
    hasScopedLabelsFeature,
    initialSort,
    isPublicVisibilityRestricted,
    isSignedIn,
    newMergeRequestPath,
    showExportButton,
    issuableType,
    email,
    rssUrl,
    releasesEndpoint,
    canBulkUpdate,
    environmentNamesPath,
    mergeTrainsPath,
    initialEmail,
    emailsHelpPagePath,
    quickActionsHelpPath,
    markdownHelpPath,
    resetPath,
    showNewResourceDropdown,
  } = el.dataset;

  return initVueApp({
    el,
    name: 'MergeRequestsListRoot',
    apolloProvider: new VueApollo({
      defaultClient,
    }),
    router: new VueRouter({
      base: window.location.pathname,
      mode: 'history',
      routes: [{ path: '/' }],
    }),
    provide: {
      fullPath,
      autocompleteAwardEmojisPath,
      mergeRequestSourceBranchesPath,
      mergeRequestTargetBranchesPath,
      hasAnyMergeRequests: parseBoolean(hasAnyMergeRequests),
      hasScopedLabelsFeature: parseBoolean(hasScopedLabelsFeature),
      initialSort,
      isPublicVisibilityRestricted: parseBoolean(isPublicVisibilityRestricted),
      isSignedIn: parseBoolean(isSignedIn),
      newMergeRequestPath,
      showExportButton: parseBoolean(showExportButton),
      issuableType,
      email,
      rssUrl,
      releasesEndpoint,
      canBulkUpdate: parseBoolean(canBulkUpdate),
      environmentNamesPath,
      mergeTrainsPath,
      initialEmail,
      emailsHelpPagePath,
      quickActionsHelpPath,
      markdownHelpPath,
      resetPath,
      getMergeRequestsQuery,
      getMergeRequestsCountsQuery,
      getMergeRequestsApprovalsQuery,
      exportMergeRequestsCsvMutation,
      isProject,
      namespaceId: namespaceId ? `${namespaceId}` : null,
      showNewResourceDropdown: parseBoolean(showNewResourceDropdown),
    },
    component: MergeRequestsListApp,
  });
}
